import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateLocalizedContentsMutationVariables = Types.Exact<{
  input: Types.CreateLocalizedContentsInput;
}>;


export type CreateLocalizedContentsMutation = { createLocalizedContents: { languageConfigs: Array<{ contentId: string, languageType: Types.LanguageEnum, jobStatus?: Types.JobEntityStatusEnum | null, jobScheduleId?: string | null }> } };


export const CreateLocalizedContentsDocument = /*#__PURE__*/ gql`
    mutation CreateLocalizedContents($input: CreateLocalizedContentsInput!) {
  createLocalizedContents(data: $input) {
    languageConfigs {
      contentId
      languageType
      jobStatus
      jobScheduleId
    }
  }
}
    `;

export function useCreateLocalizedContentsMutation() {
  return Urql.useMutation<CreateLocalizedContentsMutation, CreateLocalizedContentsMutationVariables>(CreateLocalizedContentsDocument);
};